/* eslint-disable no-magic-numbers */
/* eslint-disable array-bracket-newline */

export const magicNumbers = {
	month: {
		in: {
			year:   ( 1 / 12 ),
			day:  ( 365 / 12 ),
		},
		to: {
			hours:   ( 7 * 24 ),           //    168
			minutes: ( 7 * 24 * 60 ),      //  10080
			seconds: ( 7 * 24 * 60 * 60 ), // 604800
		},
	},
	week: {
		in: {
			year : 52,
		},
		to: {
			hours:   ( 7 * 24 ),           //    168
			minutes: ( 7 * 24 * 60 ),      //  10080
			seconds: ( 7 * 24 * 60 * 60 ), // 604800
		},
	},
	day: {
		in: {
			year: 365,
			month: ( 365 / 12 ), // 30.41667 days per month on average
			week:   7, // 0.1428
		},
		to: {
			hours:       ( 24 ),
			minutes:     ( 24 * 60 ),
			seconds:     ( 24 * 60 * 60 ),
			miliseconds: ( 24 * 60 * 60 * 1000),
		}
	},
	hour: {
		in: {
			year:  ( 24 * 365 ),      // 8760
			month: ( 24 * 365 / 12 ), //  730
			week:  ( 24 * 7 ),      //  168
			day:   ( 24 )
		}
	},
	minutes: {
		in: {
			halfHour: ( 30 ),
			hour:     ( 60 ),
			day:      ( 60 * 24 ),
			week:     ( 60 * 24 * 7 ),
		}
	},
	seconds: {
		in: {
			minute:   ( 60 ),
			halfHour: ( 60 * 30 ),
			hour:     ( 60 * 60 ),
			day:      ( 60 * 60 * 24 ),
			week:     ( 60 * 60 * 24 * 7 ),
		}
	},
	ms: {
		in: {
			minute:   ( 1000 * 60 ),
			halfHour: ( 1000 * 60 * 30 ),
			hour:     ( 1000 * 60 * 60 ),
			day:      ( 1000 * 60 * 60 * 24 ),
			week:     ( 1000 * 60 * 60 * 24 * 7 ),
		}
	},
};

export const WK_LENGTH = {
	FUN: [3],
	BAS: [4,6],
	ADV: [4,6,8],
	TST: [1,2,3,4,5,6,7,8],
};

export const EVENT_LENGTH = {
	"test": 		[1,2,3,4,5,6,7,8],
	"executive":		[12],
	"advanced": 	[4,6,8],
	"fundamentals": [3],
};

export const commonStrings = {
	days : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	months : ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
};


export const MGMT_CONSTS = {
	WK_LENGTH,
	EVENT_LENGTH,
	magicNumbers
};